
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'DetailBox',
  props: {
    menus: { type: Object, required: true },
  },
  data() {
    return {
      selectedBox: '',
    };
  },
  methods: {
    selectBox(BoxName: string) {
      this.selectedBox = BoxName;
    },
  },
  created() {
    this.selectBox(this.menus[0].id);
  },
});
